const INIT_STATE = {
  isAllowed: false
};

const EditRestriction = (state = INIT_STATE, action) => {
  switch (action.type) {
    case 'EDIT_RESTRICTION':
      return {
        ...state,
        isAllowed: action.payload.isAllowed
      };
    default:
      return state;
  }
};

export default EditRestriction;
